export enum ClassificatieEnum {
  BOUW = 'Bouw',
  SLOOP = 'Sloop',
}
